/**
 * Obrigatoriedade de um campo no formulário.
 *
 * A do próprio atributo (`isRequired`) é a configuração BASE e nunca se perde: um template não pode tornar opcional um campo que o
 * atributo declara obrigatório. O template (config `IsRequired` do campo) só SOMA: torna obrigatório um campo que o atributo deixa
 * opcional. O valor da config chega como texto ("True", "False", "1"…), então "False" não pode valer como preenchido.
 */
export function isConfigTruthy (value) {
  if (value === true) return true
  if (value === false || value === null || value === undefined) return false

  const text = String(value).trim().toLowerCase()
  return text === 'true' || text === '1'
}

/** `baseRequired`: o que o atributo já exige (isRequired, e a chave natural onde a tela a trata como obrigatória). `templateConfig`: a linha IsRequired do template, se houver. */
export function resolveRequired (baseRequired, templateConfig) {
  return !!baseRequired || isConfigTruthy(templateConfig?.value)
}
